export default "__VITE_ASSET__l0SqYUxt__"